import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "monochrome-poster-page",
    style: _normalizeStyle({backgroundImage: _ctx.currentPoster})
  }, null, 4))
}